import { render, staticRenderFns } from "./AddOrEditSignatureOrInitials.vue?vue&type=template&id=1ea8460e&scoped=true&"
import script from "./AddOrEditSignatureOrInitials.vue?vue&type=script&lang=js&"
export * from "./AddOrEditSignatureOrInitials.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditSignatureOrInitials.vue?vue&type=style&index=0&id=1ea8460e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea8460e",
  null
  
)

export default component.exports